import type { RadioMessage } from '../domain/model';

export const voicePreview = [
  {
    sender: 'Leitstelle',
    text: 'Florian eins, hier Leitstelle. Wie ist die Lage bei Ihnen? Kommen.',
  },
  {
    sender: 'Florian eins',
    text: 'Hier Florian eins. Alle Kräfte vor Ort. Wir beginnen mit der Erkundung. Kommen.',
  },
  { sender: 'Leitstelle', text: 'Verstanden. Geben Sie uns anschließend eine Rückmeldung. Ende.' },
];
function bounded(text: string, max: number) {
  if (text.length <= max) return text;
  const prefix = text.slice(0, max - 1);
  return prefix.slice(0, prefix.lastIndexOf(' ')).replace(/[,;:.]+$/, '') + '.';
}
export function speechTransmission(message: RadioMessage, index: number, full = false) {
  const transmission = message.transmissions[index];
  if (!transmission) return undefined;
  if (message.kind === 'conversation')
    return { ...transmission, text: bounded(transmission.text, 1000) };
  if (full || message.kind === 'request')
    return { ...transmission, text: bounded(transmission.text, 650) };
  const sender = bounded(transmission.sender.replace(/^SIM\s+/i, ''), 85);
  if (message.kind === 'status')
    return { ...transmission, text: `${sender}. Status ${message.status ?? ''}.` };
  let text = transmission.text;
  const prefix = `, hier ${transmission.sender}. `;
  if (text.includes(prefix))
    text = `${sender}. ${text.slice(text.indexOf(prefix) + prefix.length)}`;
  return { ...transmission, text: bounded(text, message.kind === 'warning' ? 320 : 230) };
}
